// extracted by mini-css-extract-plugin
export default {"locationName":"Map_locationName__JfsDI","locationAddress":"Map_locationAddress__b1m4x","locationInfo":"Map_locationInfo__r9Ox4"};